import React from 'react'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import IntervenersList from './IntervenersList'
import IntervenerCards from './IntervenerCards'

export default function ActiveIntervenersTab ({ interveners, deleteIntervener }) {
  const screens = useBreakpoint()

  return (
    <>
      { !screens.xs && <IntervenersList interveners={interveners} deleteIntervener={deleteIntervener} /> }
      { screens.xs && <IntervenerCards interveners={interveners} /> }
    </>
  )
}
